module.exports = __webpack_public_path__ + "static/img/6.ba2adb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/6.png
// module id = 2kZ/
// module chunks = 0